import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { Spending, SpendingSummary } from '../../models/spending.model';
import { SpendingActions } from './spending.actions';

export interface SpendingState extends EntityState<Spending> {
  loading: boolean;
  error: string | null;
  summary: SpendingSummary[];
}

export const adapter = createEntityAdapter<Spending>();
const initialState: SpendingState = adapter.getInitialState({ loading: false, error: null, summary: [] });

export const spendingFeature = createFeature({
  name: 'spending',
  reducer: createReducer(
    initialState,
    on(SpendingActions.loadSpendings, (state) => ({ ...state, loading: true, error: null })),
    on(SpendingActions.loadSpendingsSuccess, (state, { spendings }) =>
      adapter.setAll(spendings, { ...state, loading: false })),
    on(SpendingActions.loadSpendingsFailure, (state, { error }) => ({ ...state, loading: false, error })),
    on(SpendingActions.loadSpendingSuccess, (state, { spending }) => adapter.upsertOne(spending, state)),
    on(SpendingActions.createSpendingSuccess, (state, { spending }) => adapter.addOne(spending, state)),
    on(SpendingActions.updateSpendingSuccess, (state, { spending }) => adapter.upsertOne(spending, state)),
    on(SpendingActions.deleteSpendingSuccess, (state, { id }) => adapter.removeOne(id, state)),
    on(SpendingActions.loadSpendingSummarySuccess, (state, { summary }) => ({ ...state, summary })),
  )
});

export const {
  name: spendingFeatureKey,
  reducer,
  selectSpendingState,
  selectLoading: selectSpendingLoading,
  selectSummary,
} = spendingFeature;

export const { selectAll } = adapter.getSelectors();
